import React, { FunctionComponent, SVGProps } from 'react';

import { Body, MainButton, Title } from '@icarros/ids-react';

import { Wrapper } from './style';

interface EmptyStateProps {
  Illustration: FunctionComponent<SVGProps<SVGSVGElement>>;
  title: string;
  body: string;
  buttonLabel: string;
  buttonAction: () => void;
  hideButtonOnDesk?: boolean;
}

export function EmptyState({
  Illustration,
  title,
  body,
  buttonLabel,
  buttonAction,
  hideButtonOnDesk
}: EmptyStateProps): React.JSX.Element {
  return (
    <Wrapper hideButtonOnDesk={hideButtonOnDesk}>
      <Illustration />
      <Title>{title}</Title>
      <Body size="body_2">{body}</Body>
      <MainButton onClick={buttonAction} text={buttonLabel} isMobile />
    </Wrapper>
  );
}
